require("jquery-nice-select/js/jquery.nice-select.min.js");
require('../../../../../corporate-template/js/feature/form.js');
require('./custom-validation.js');
(function ($, DGS) {
  DGS.OnLoad.getInstance().register(function () {
    adjustLabelWhenFieldRequired();
    function adjustLabelWhenFieldRequired() {
      var formFields = document.querySelectorAll('.scfSectionContent > div');
      formFields.forEach(function (field) {
        var required = field.querySelector('.scfRequired');
        var validatorRequired = field.querySelector('.scfValidatorRequired');
        var isRequired = required !== null || validatorRequired !== null;
        var isRadioList = field.classList.contains('scfRadioButtonListBorder');
        var mark = document.createElement('span');
        mark.innerHTML = "*";
        if (isRadioList && isRequired) {
          field.querySelector('.scfRadioButtonListLabel').appendChild(mark);
        }
        if (!isRadioList && isRequired) {
          field.querySelector('label').appendChild(mark);
        }
      });
    }
    customizeRadioOrCheckbox();
    function customizeRadioOrCheckbox() {
      var containers = document.querySelectorAll('.scfSectionContent .scfRadioButtonList tr td label, .scfSectionContent .scfCheckbox label');
      containers.forEach(function (container) {
        var input = container.parentNode.querySelector('input');
        var customCheckmark = document.createElement('span');
        customCheckmark.classList.add('checkmark');
        container.appendChild(input);
        container.appendChild(customCheckmark);
      });
    }
    function niceSelectScroll() {
      var listContainers = document.querySelectorAll('.form .nice-select');
      listContainers.forEach(function (container) {
        container.addEventListener('focus', function (e) {
          var list = container.querySelector('.list');
          var firstItemEmpty = container.querySelector('.option[data-value=""]:first-of-type') !== null;
          var counter = 0;
          document.addEventListener('keydown', function (e) {
            var listItemHeight = container.querySelector('.option:not([data-value=""])').offsetHeight;
            var listIsAtTop = list.scrollTop === 0;
            if (e.keyCode === 40) {
              if (firstItemEmpty && listIsAtTop && counter === 0) {
                counter++;
              } else {
                list.scrollTop += listItemHeight;
              }
            }
            if (e.keyCode === 38) {
              if (listIsAtTop) {
                counter = 0;
              }
              list.scrollTop -= listItemHeight;
            }
          });
        });
      });
    }
    niceSelectScroll();
  });
})(jQuery, window.DGS);